import styled from "styled-components";
import { Input, Icon } from "antd";
import { DataHeading } from "../commonStyles";

export const FooterContainer = styled.div`
  padding: 30px 20px 7px 20px;
  margin-top: 50px;
  background-color: ${props => props.theme.fontColors.headingColor};
  color: white;
  @media only screen and (max-width: 991.92px) {
    padding: 30px 0px 7px 0px;
    margin-top: 40px;
  }
  & .ant-input-affix-wrapper .ant-input-suffix {
    right: 0px;
    background: #006778;
    padding: 12px;
    border: 1px solid white;
    color: white;
  }
  & .ant-input {
    height: 40px;
    border-radius: 0px;
    border: 1px solid white;
  }
  & .ant-input-affix-wrapper .ant-input:not(:last-child) {
    padding-right: 0px;
  }
  & .ant-col-lg-6{
    text-align: right;
  }
  @media only screen and (min-width: 475px) and (max-width: 767px){
   .footerLinks{
      text-align: left;
      padding-left: 20%;
    }
  }
  @media only screen and (max-width: 475px){
    .footerLinks{
       text-align: left;
     }
   }
`;

export const Container1 = styled.div`
  @media only screen and (max-width: 991.92px) {
    margin-bottom: 45px;
  }
`;

export const Newsletter = styled.div`
  @media only screen and (max-width: 991.92px) {
    margin-bottom: 70px;
    margin-top: 15px;
  }
`;

export const CopyRight = styled.div`
  background-color: #f5f5f5;
  padding-top: 25px;
  padding-bottom: 35px;
  text-align: center;
`;

export const CopyRightLogo = styled.img`
  width: 162px;
  height: 46px;
`;

export const FooterContent = styled(DataHeading)`
  cursor: pointer;
  text-transform: uppercase;
  font-size: ${props => props.theme.fontSize.tertiary};
  color: white;
  margin-bottom: 23px;
  line-height: normal;
  @media only screen and (max-width: 991.92px) {
  font-size: ${props => props.theme.fontSize.quaternary};
  }
  @media only screen and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.tertiary};
    padding-bottom:16px
  }
`;

export const BrandLogoContainer = styled.div`
  @media only screen and (max-width: 991.92px) {
    text-align: center;
  }
`;

export const CopyRightContent = styled(DataHeading)`
  font-size: 12px;
  color: #505050;
  margin-top: 17px;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  @media only screen and (max-width: 991.92px) {
    font-size: 12px;
  }
`;

export const EndowmentRight = styled(CopyRightContent)`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  color: #ffffff;
  font-size: 12px;
  margin-top: 0px;
  letter-spacing: 0px;
  font-weight: normal;
  @media only screen and (max-width: 991.92px) {
    text-align: center;
  }
`;

export const SubscribeContent = styled(DataHeading)`
  font-size: 18px;
  line-height: 1;
  letter-spacing: 0.5px;
  font-family: BerkeleyStd-Book;
  font-weight: normal;
  color: #ffffff;
  @media only screen and (max-width: 991.92px) {
    font-size: 18px;
  }
`;

export const InputContent = styled.div`
  margin-top: 18px;
`;

export const BrandLogo = styled.img`
  width: 120px;
  height: 48px;
`;

export const SocialMediaContainer = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  display: flex;
  margin-top: 35px;
  margin-bottom: 35px;
  cursor: pointer;
  @media only screen and (max-width: 991.92px) {
    justify-content: center;
  }
  & span{
    color: #b6bdbd;
    font-size: 12px;
    line-height: 2;
  }
`;

export const SocialMediaIcon = styled.img`
  padding-right: 5px;
  font-size: 20px;
  width: 25px;
  height: 20px;
  display: inline-block;
`;

export const InputSearch = styled(Input)`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  line-height: 1.13;
  & ::placeholder{
    font-size: 16px;
    color: #999;
    letter-spacing: 0px;
  }
  &.newsletter:-ms-input-placeholder{
    font-size: 16px;
    color: #999;
    letter-spacing: 0px;
  }
  & ::-ms-input-placeholder{
    font-size: 16px;
    color: #999;
    letter-spacing: 0px;
  }
`;

export const IconSend = styled(Icon)``;
